export default function AboutDeveloper() {
  return (
    <section id="developer" className="bg-[#3A4B3A] text-white" data-testid="about-developer-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <p className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#CBA365] mb-4">
              About the developer
            </p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              Loughrea Energy Ltd, owned by Obton.
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-white/85">
              Loughrea Energy Ltd is the company taking the project forward. It
              is owned by <strong>Obton</strong>, an established international
              solar developer founded in 2009 with offices including in Ireland.
              The project is being developed in conjunction with local
              landowners.
            </p>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/15 border border-white/15 rounded-sm overflow-hidden">
              {[
                { v: "2009", l: "Obton founded" },
                { v: "2,155 MW", l: "Solar in operation globally" },
                { v: "1 GW", l: "Ireland pipeline" },
                { v: "Tuam", l: "Energy Park, Co. Galway" },
                { v: "Ballycrissane", l: "Solar farm, Co. Galway" },
                { v: "Local", l: "Landowner partnerships" },
              ].map((s, i) => (
                <div key={i} className="bg-[#3A4B3A] p-6 lg:p-7" data-testid={`developer-stat-${i}`}>
                  <div className="font-serif-display text-2xl lg:text-3xl tracking-tight">{s.v}</div>
                  <div className="mt-2 text-[12.5px] text-white/75">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
